import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { TelephonyConfigServiceRB } from 'rainbow-web-sdk/services/telephonyConfig/telephonyConfig.service';

export class TelephonyConfigPlugin extends Plugin {
    public static initialize(): void {
        Plugin.initialize();
        if (!window.rainbow.plugins[TelephonyConfigPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[TelephonyPlugin] initialized");
            window.rainbow.plugins[TelephonyConfigPlugin.name] = new TelephonyConfigPlugin();
            TelephonyConfigServiceRB.getInstance();
        }
        return window.rainbow.plugins[TelephonyConfigPlugin.name];
    }

    private constructor() {
        super();
    }
}
